/**
 * getWindowTop
 *
 * Return window scrolling position
 */

export default function () {
  return window.pageYOffset || document.documentElement.scrollTop
}
